import { TemplateType_Slug, Template } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { useTranslation } from '@frontend/i18n';
import { TemplateSelector } from '@frontend/integrated-messaging';
import { useMultiStepModal } from '@frontend/payments-multistep-modal';
import { Modal } from '@frontend/design-system';
import { BULK_CREATE_STEPS } from '../bulk-create-steps-key-title';
import { styles } from './styles';

type SelectTemplateStepProps = {
  locationIds: string[];
  onSelectTemplate: (template?: Template) => void;
};
export const SelectTemplateStep = ({ locationIds, onSelectTemplate }: SelectTemplateStepProps) => {
  const { t } = useTranslation('payments');

  const { goToStep, closeModal, goBack } = useMultiStepModal();

  return (
    <>
      <Modal.Body css={styles.modalBody()}>
        <TemplateSelector
          groupIds={locationIds}
          templateTypes={[TemplateType_Slug.MANUAL_PAYMENT_REQUEST]}
          onSelectTemplate={(template) => {
            onSelectTemplate(template);
            goToStep(BULK_CREATE_STEPS.SEND_SMS.id);
          }}
          onOpenSettings={closeModal}
        />
      </Modal.Body>
      <Modal.Footer
        tertiary={{
          label: t('Back'),
          onClick: () => goBack(),
        }}
      />
    </>
  );
};
